import React from "react";
import "devextreme/dist/css/dx.light.css";
import "./OrganizationToolTip.scss";
import PropTypes from "prop-types";
import { Button } from "devextreme-react/button";
import { orgHierarchySvg, azureCopySvg } from "../../Assets/SVGs/organizationSVGs";
import { orgDataPropTypes } from "../../Constants/propTypes";

const OrgDetailsToolTip = ({
  orgData,
  organizationHierarchyName,
  supRole,
  copyAzureGroupID,
}) => (
  <div>
    <div className="orgHierarchyContainer">
      <div className="item">
        <div className="orgHierarchyClassContainer">
          <div className="orgHierarchyFlexContainer">
            <div className="orgHierarchyClassSvg">
              {orgHierarchySvg}
              &nbsp;
            </div>
            <div className="orgHierarchyClassName">
              {organizationHierarchyName(orgData?.parentId, orgData?.name)}
            </div>
          </div>
        </div>
      </div>
    </div>
    {orgData?.groupId !== null && supRole === true ? (
      <div className="copyGroupId">
        <div className="CopyGridIDTitle">
          <b>Azure AD group ID : </b>
        </div>
        <div>{orgData?.groupId}</div>
        <Button
          className="copy-org-icon"
          icon="copyIcon"
          onClick={copyAzureGroupID}
          stylingMode="text"
        >
          {azureCopySvg}
        </Button>
      </div>
    ) : (
      <div />
    )}
    {orgData?.groupId !== null && supRole === true ? (
      <hr className="footerLine" />
    ) : (
      <span />
    )}
    <div className="orgDetailsContainer">
      <div className="orgDetailsHeaderDetails">Organization details</div>
      <div className="orgDetailsForDetails">{orgData?.organizationDetails}</div>
    </div>
    <br />
  </div>
);
OrgDetailsToolTip.propTypes = {
  orgData: orgDataPropTypes.isRequired,
  organizationHierarchyName: PropTypes.func.isRequired,
  supRole: PropTypes.bool.isRequired,
  copyAzureGroupID: PropTypes.func.isRequired,
};
export default OrgDetailsToolTip;
